import { ObjectValues } from "@/src/shared/types/objectValues";
import type { DSInputToken } from "@/src/design_system/form_elements/token_input/types/props";
import type { DSFocusableEmits } from "@/src/design_system/shared/types/emits";

export const DS_TOKEN_INPUT_COMMIT_REASON = {
  Key: "key",
  Move: "move",
  Blur: "blur",
} as const;

export type DSTokenInputCommitReason = ObjectValues<typeof DS_TOKEN_INPUT_COMMIT_REASON>;

export interface DSTokenInputCommitPayload {
  draft: string;
  reason: DSTokenInputCommitReason;
  key?: string;
}

export interface DSTokenInputTokenPayload {
  token: DSInputToken;
  index: number;
}

export interface DSTokenInputEmits extends DSFocusableEmits {
  (e: "update:modelValue", value: string): void;
  (e: "update:tokens", tokens: DSInputToken[]): void;
  (e: "update:caret", caret: number): void;
  (e: "commit", payload: DSTokenInputCommitPayload): void;
  (e: "token:edit", payload: DSTokenInputTokenPayload): void;
  (e: "token:remove", payload: DSTokenInputTokenPayload): void;
  (e: "token:select", payload: DSTokenInputTokenPayload | null): void;
  (e: "token:click", payload: DSTokenInputTokenPayload, event: MouseEvent): void;
  (e: "clear"): void;
  (e: "input", event: Event): void;
  (e: "keydown", event: KeyboardEvent): void;
  (e: "keyup", event: KeyboardEvent): void;
  (e: "click", event: MouseEvent): void;
  (e: "select", event: Event): void;
}
